var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "checkbox"
    ? _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.valueProxy,
            expression: "valueProxy"
          }
        ],
        staticClass: "vue-book-input",
        attrs: {
          name: _vm.name,
          placeholder: _vm.placeholder,
          autocomplete: "off",
          type: "checkbox"
        },
        domProps: {
          checked: Array.isArray(_vm.valueProxy)
            ? _vm._i(_vm.valueProxy, null) > -1
            : _vm.valueProxy
        },
        on: {
          keydown: [
            function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              $event.preventDefault()
              _vm.$emit("up")
            },
            function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              $event.preventDefault()
              _vm.$emit("down")
            }
          ],
          keypress: function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            _vm.$emit("enter")
          },
          focus: function($event) {
            _vm.$emit("focus")
          },
          blur: function($event) {
            _vm.$emit("blur")
          },
          change: function($event) {
            var $$a = _vm.valueProxy,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.valueProxy = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.valueProxy = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.valueProxy = $$c
            }
          }
        }
      })
    : _vm.type === "radio"
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.valueProxy,
              expression: "valueProxy"
            }
          ],
          staticClass: "vue-book-input",
          attrs: {
            name: _vm.name,
            placeholder: _vm.placeholder,
            autocomplete: "off",
            type: "radio"
          },
          domProps: { checked: _vm._q(_vm.valueProxy, null) },
          on: {
            keydown: [
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                _vm.$emit("up")
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                _vm.$emit("down")
              }
            ],
            keypress: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              _vm.$emit("enter")
            },
            focus: function($event) {
              _vm.$emit("focus")
            },
            blur: function($event) {
              _vm.$emit("blur")
            },
            change: function($event) {
              _vm.valueProxy = null
            }
          }
        })
      : _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.valueProxy,
              expression: "valueProxy"
            }
          ],
          staticClass: "vue-book-input",
          attrs: {
            name: _vm.name,
            placeholder: _vm.placeholder,
            autocomplete: "off",
            type: _vm.type
          },
          domProps: { value: _vm.valueProxy },
          on: {
            keydown: [
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                _vm.$emit("up")
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                _vm.$emit("down")
              }
            ],
            keypress: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              _vm.$emit("enter")
            },
            focus: function($event) {
              _vm.$emit("focus")
            },
            blur: function($event) {
              _vm.$emit("blur")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.valueProxy = $event.target.value
            }
          }
        })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }